import generateLink from '@/utilities/generateLink';
import cardArchiveMixin from '@/mixins/cardArchiveMixin';
import getBranchName from '@/utilities/getBranchName';
import { ResourceType } from '@/types/resources';

export default {
  mixins: [cardArchiveMixin],
  computed: {
    teamSlug() {
      return this.$store.getters.getTeamSlug;
    },

    page() {
      return this.$store.getters.getPage;
    },

    pageTitle() {
      return this.page.title || this.translate('pageTitlePlaceholder');
    },

    pageId() {
      return this.page.id;
    },

    board() {
      return this.$store.getters.currentBoard;
    },

    boardTitle() {
      return this.board.title;
    },

    boardId() {
      if (this.embed) {
        return this.resourceId;
      }
      return this.board.id;
    },

    currentProject() {
      return this.$store.getters.getCurrentProject;
    },

    projectId() {
      return this.currentProject.id;
    },

    viewTitle() {
      return this.$store.getters.getSelectedView?.name || '';
    },

    viewId() {
      return this.$store.getters.getSelectedView?.id || '';
    },

    myWorkUserId() {
      return this.$store.getters.getMyWorkUserId;
    },
    myWorkSelectedTabId() {
      return this.$store.getters.getMyWorkSelectedTabId(this.myWorkUserId);
    },
  },

  methods: {
    copyToClipboard(
      text,
      notificationMessage = this.translate('linkCopiedToClipboard'),
      isGitBranchName = false
    ) {
      navigator.clipboard.writeText(text);

      this.$store.dispatch('addUiNotification', {
        message: notificationMessage,
        icon: isGitBranchName ? 'git-pull-request' : 'link-st',
        duration: 4000,
      });
    },

    generateLink(type, resourceId) {
      switch (type) {
        case 'sprintcard':
        case 'card': {
          const card = this.$store.getters.getCardById(resourceId);
          this.copyToClipboard(generateLink(type, this.teamSlug, card.id, card.title));
          break;
        }
        case 'page':
          this.copyToClipboard(generateLink('page', this.teamSlug, this.pageId, this.pageTitle));
          break;
        case 'board':
          this.copyToClipboard(generateLink('board', this.teamSlug, this.boardId, this.boardTitle));
          break;
        case 'boards':
          this.copyToClipboard(generateLink(this.$cons.projectSlug, this.teamSlug, this.projectId));
          break;
        case 'pages':
        case 'sprints':
          this.copyToClipboard(
            generateLink(this.$cons.projectSlug, this.teamSlug, this.projectId, '', type)
          );
          break;
        case 'view':
          this.copyToClipboard(generateLink('view', this.teamSlug, this.viewId, this.viewTitle));
          break;
        case 'views':
          this.copyToClipboard(generateLink('views', this.teamSlug));
          break;
        case 'newview':
          this.copyToClipboard(generateLink('newview', this.teamSlug));
          break;
        case 'member': {
          this.copyToClipboard(
            generateLink('member', this.teamSlug, this.myWorkUserId, '', this.myWorkSelectedTabId)
          );
          break;
        }
        case 'manage-spaces':
          this.copyToClipboard(generateLink('manage-spaces', this.teamSlug));
          break;
        case 'create-space':
          this.copyToClipboard(generateLink('create-space', this.teamSlug));
          break;
        case ResourceType.EpicsBoard:
          this.copyToClipboard(generateLink(this.$constants.epicsBoardRoute.path, this.teamSlug));
          break;
        case ResourceType.Epic: {
          const { id = '', title = '' } = this.$store.getters.getCardById(resourceId);
          const tabId = this.$store.getters.getEpicSelectedTabId(resourceId);
          this.copyToClipboard(
            generateLink(this.$constants.epicRoute.path, this.teamSlug, id, title, tabId)
          );
          break;
        }
        case 'sprint':
          this.copyToClipboard(
            generateLink('sprint', this.teamSlug, this.boardId, this.boardTitle)
          );
          break;
        default:
          break;
      }
    },

    generateGitBranchName(cardId, character = '_') {
      const card = this.$store.getters.getCardById(cardId);
      const gitName = getBranchName(card.id, card.title, character);
      return this.copyToClipboard(gitName, this.translate('branchCopiedToClipboard'), true);
    },

    duplicateCard(cardId, popupViewType) {
      this.$store.dispatch('setShowDuplicateCardPopup', `${cardId}-${popupViewType}`);
    },

    openSetParentCardPopup(action, popupViewType) {
      this.$store.dispatch('setShowSetParentCardPopup', `${action}-${popupViewType}`);
    },

    deleteCard(type, cardId) {
      this.$store.dispatch('deletePopupId', `${type}-${cardId}`);
    },
  },
};
